import { Component, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { QuestionFacade } from '../../facade/question.facade';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ClientType } from '../../service/type-detector.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [AsyncPipe, TranslatePipe],
})
export class FooterComponent {
  private readonly questionFacade = inject(QuestionFacade);

  year = new Date().getFullYear();
  b2b$: Observable<boolean>;

  constructor() {
    this.b2b$ = this.questionFacade.findData((state) => state.type).pipe(map((type) => type === ClientType.B2B));
  }
}
